/**
 * Created by Mikhail Menshenin on 28.10.2025
 */

// html panel stacked above the DebugStats profiler in the lower left corner, shares its look and enabled state
const GameStatsView = function () {
    this.panel = cleverapps.debugStats && cleverapps.debugStats.addPanel();
    if (!this.panel) {
        return;
    }

    this.panel.style.fontWeight = "normal";
    this.panel.style.textAlign = "left";
    this.handlers = [
        Game.currentGame.on("updateStats", this.updateStatsText.bind(this)),
        cleverapps.flags.on("change:statsShow", this.updateStatsText.bind(this))
    ];

    Game.currentGame.updateStats({});
    this.updateStatsText();
};

GameStatsView.prototype.updateStatsText = function () {
    const game = Game.currentGame;
    const stats = Object.assign({ level: game.level.getHumanReadableNumber() }, game.stats);

    this.panel.replaceChildren(...Object.keys(stats).map((key) => {
        const value = stats[key];
        const line = document.createElement("div");
        line.innerText = `${key}: ${value && value.text !== undefined ? value.text : value}`;
        line.style.color = value && value.color || "";
        line.style.fontWeight = value && value.bold ? "bold" : "";
        return line;
    }));
    this.panel.style.display = cleverapps.flags.statsShow ? "" : "none";
};

GameStatsView.prototype.remove = function () {
    if (!this.panel) {
        return;
    }

    this.handlers.forEach((handler) => handler.clear());
    cleverapps.debugStats.removePanel(this.panel);
    this.panel = undefined;
};
